// extracted by mini-css-extract-plugin
module.exports = {"box-circle":"userBox_box-circle__3vTlu","text-user":"userBox_text-user__1xG_J"};